<template>
  <div class="art-item item3-add-cont">
    <common-top :commonTopData="commonTopData"></common-top>
    <div class="page-title" v-text="pageTitle"></div>
    <div class="top-title">
      <el-form class="add-form" :model="addForm" :disabled="isDisabled" :label-width="labelWidth">
        <el-form-item v-for="(el,index) in formList" :key="index" :label="el.label" :prop="el.prop">
          <el-input
          v-if="el.type=='input'"
            v-model="addForm[el.prop]"
            placeholder="请输入"
            clearable
            show-word-limit
          ></el-input>
          <el-select v-else-if="el.type=='select'" v-model="addForm[el.prop]" placeholder="请选择" >
            <el-option
              v-for="item in el.option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <w-upload-image
          v-else-if="el.type=='imga'"
            style="overflow: hidden;"
            class="upload-img"
            :imgWidth="el.width || 620"
            :imgHeight="el.height || 620"
            :size="10"
            accept=".jpg,.png,.webp"
            :tipsText="tipsText"       
            v-model="addForm[el.prop]">
          </w-upload-image>
        </el-form-item>
      </el-form>
    </div>
   
    <div class="foot-btn">
      <el-button size="small" @click="backFn">返回</el-button>
      <el-button size="small" type="primary" @click="createFn" :disabled="isDisabled">保存</el-button>
    </div>
  </div>
</template>

<script>
import commonTop from "@/components/commonTop.vue"
export default {
  components: {
    commonTop,


  },
  data() {
    // 这里存放数据
    return {
        formList:[
          {label:'厂商',prop:'brand',type:'select',option:[],check:true,check_tip:'请选择厂商'},
          {label:'快游戏名',prop:'app_name',type:'input',check:true,check_tip:'请填写快游戏名'},
          {label:'快游戏包名',prop:'package',type:'input',check:true,check_tip:'请填写快游戏包名'},
          {label:'dp_link',prop:'dp_link',type:'input',check:true,check_tip:'请填写dp_link'},
          {label:'ICON',prop:'icon',type:'imga',check:true,check_tip:'请上传ICON'},
          {label:'广告素材图片',prop:'adv_material_pic',type:'imga',check:true,check_tip:'请上传广告素材图片'},
          {label:'广告素材标题',prop:'adv_title',type:'input',check:true,check_tip:'请填写广告素材标题'},
        ],



      pageTitle: '新建內容',
      id: this.$route.query.id,
      type: this.$route.query.type,
      isDisabledRadio: this.$route.query.type == 'look' || this.$route.query.type == 'edit',
      labelWidth: '100px',
      isDisabled: false, // 是否禁用
      commonTopData : {
        commonleftbtn: [],
      },
      addForm: {},
     
      tipsText: 'png/jpg/webp格式',

    }
  },
  
  mounted() {
    this.getBrand((da)=>{
      this.formList[0].option =  da.map(e=>{
        return {label:e,value:e}
      })
    })
    if (this.type === 'edit') {
      this.pageTitle = '编辑'
      this.isDisabled = false
      this.contentDetail()
    }
  },
  // 方法集合
  methods: {
    backFn(){
    this.$router.push('/art/baseAdvList')
  },
    getPopData (pr) {
      this.api.subjectList(pr||'').then(res => {
				if (!res) return
				let { data, total } = res
				this.tableData = data
        this.total = total
			})
		},
 
    createFn() {
      if(this.addType){
        this.$message('正在处理请稍后')
        return
      }
      for(let i=0,n=this.formList.length;i<n;i++){
        let po = this.formList[i];
        if(po.check && !this.addForm[po.prop]){
          this.$message(po.check_tip)
          return
        }
      }

      let rulld = 'fastapptoolAddBaseAdv';
      if(this.type == 'edit'){
        rulld = 'fastapptoolUpdateBaseAdvt';
      }
      this.addType = true;
      this.api[rulld](this.addForm).then(res => {
        this.addType = false;
          if (!res) return
          this.$message.success('操作成功')
          this.backFn()
      }).catch(()=>{
        this.addType = false;
        this.$message('操作失败请联系管理员')
      })
    
    },
    contentDetail () {
      try {
          this.addForm = JSON.parse(localStorage.getItem('kyysetData'))
      } catch (error) {
        console.log(error)
      }

    },
    
   
 
  },
};
</script>
<style>
.boxdop .el-dialog__footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
}
.boxdop .el-dialog__body{
  padding-bottom: 70px !important;
}
</style>
<style lang='scss' scoped>
.item3-add-cont {
  height: 100vh;
  background-color: #fff;
  .page-title {
    margin: 0 0 30px 30px;
    font-size: 16px;
  }
  .top-title {
    padding-left: 150px;
    .add-form {
      .tips {
        color: #979797;
      }
    }
    .title-item {
      display: flex;
      margin-bottom: 15px;
      .select-btn {
        display: inline-block;
        width: 110px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;
        border: 1px solid #c4c4c4;
      }
    }
  }
  .content {
    position: relative;
    margin-top: 30px;
    padding-left: 150px;
    border-top: 1px solid #e5e5e5;
    .art-radio-group {
      display: inline-block;
    }
    .jump-link-group {
      .art-radio-group {
        display: inline-block;
        margin: 0;
      }
      .item8 {
        width: 598px;
        padding: 20px;
        border: 1px dashed #999;
        border-radius: 4px;
      }
      .form-item {
        position: relative;
        .form-item-title {
          display: inline-block;
          min-width: 100px;
          color: #606266;
        }
        .link-box {
        }
        .sub-item {
          margin-left: 100px;
        }
      }
      .form-item1 {
        display: flex;
      }
      .disabled-box {
        pointer-events: none;
        cursor: default;
      }
    }
    .content-title {
      display: inline;
      position: relative;
      left: -120px;
    }
    .tips {
      margin-left: 10px;
      display: inline;
      color: #828282;
    }
    .all-online {
      width: 400px;
      margin: 20px 0 10px;
      text-align: right;
      cursor: pointer;
      color: #33b3ff;
    }
  }
  .foot-btn {
    .el-button {
      width: 100px;
    }
  }
  .item3-add-pop {
    /deep/.el-dialog {
      width: 60%;
    }
    ul {
      display: flex;
      align-items: center;
      justify-content: center;
      li {
        margin-right: 20px;
        cursor: pointer;
        .title {
          display: block;
        }
      }
    }
  }
  .el-input,
  .el-select,
  .el-textarea {
    width: 460px !important;
    /deep/.el-input__count {
      bottom: -10px;
    }
  }
}
</style>

<style lang="scss">
  .item3-add-cont {
    .add-form {
      .el-textarea__inner {
        font-family: auto;
      }
    }
  }
  .sub-item .w-upload-image-review {
    img {
      width: 100%;
    }
  }
 .tags_d>span{
    display: inline-block;
    vertical-align: top;
    padding: 2px 5px;

    margin: 2px;
    font-size: 12px;
    border-radius: 5px;
    color: #fff;
    background-color: whitesmoke;

    color: #979797;
    border: 1px solid #eaeaea;
 }
</style>